document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('car-scents-form');
  const submitBtn = document.getElementById('submitBtn');
  const buttonText = document.getElementById('button-text');
  const priceWrapper = document.getElementById('total-price');
  const modal = document.getElementById('car-scent-modal');
  const modalMessage = document.getElementById('modal-message');
  const closeModal = document.getElementById('close-modal');
  const allSelects = Array.from(document.querySelectorAll('.select'));
  const paragraph1 = document.getElementById('paragraph-1');
  const paragraph2 = document.getElementById('paragraph-2');

  // --- KONFIGURACJA RABATU BUNDLA ---
  const BUNDLE_DISCOUNT = 0.4755;

  // --- Pomocnicze: utwórz spany cen, jeśli ich nie ma ---
  function ensurePriceSpans() {
    if (!priceWrapper) return { currentEl: null, compareEl: null };

    let currentEl = document.getElementById('current-price');
    let compareEl = document.getElementById('compare-price');

    if (!currentEl) {
      currentEl = document.createElement('span');
      currentEl.id = 'current-price';
      priceWrapper.appendChild(currentEl);
    }
    if (!compareEl) {
      compareEl = document.createElement('span');
      compareEl.id = 'compare-price';
      compareEl.style.textDecoration = 'line-through';
      compareEl.style.color = '#999';
      compareEl.style.marginLeft = '5px';
      priceWrapper.appendChild(compareEl);
    }
    return { currentEl, compareEl };
  }

  // --- Helpery walutowe ---
  function getUserLocale() {
    return navigator.language || 'en-US';
  }
  function getShopCurrency() {
    return (window.Shopify && window.Shopify.currency && Shopify.currency.active) || 'USD';
  }
  function formatPrice(amount) {
    const currency = getShopCurrency();
    return new Intl.NumberFormat(getUserLocale(), {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  }
  function roundMoney(n) {
    return Math.round(n * 100) / 100;
  }
  function applyBundleDiscount(amount) {
    return roundMoney(amount * (1 - BUNDLE_DISCOUNT));
  }

  // --- Suma cen ---
  function getTotals() {
    let total = 0;
    let totalCompare = 0;

    allSelects.forEach(select => {
      const opt = select.options[select.selectedIndex];
      if (!opt || !select.value) return;

      const p = parseFloat(opt.dataset.price);
      const c = parseFloat(opt.dataset.compare || opt.dataset.price);

      if (!isNaN(p)) total += p;
      if (!isNaN(c)) totalCompare += c;
    });

    return { total, totalCompare };
  }

  // --- Wyłączenie duplikatów + sold out ---
  function updateOptionsAvailability() {
    const selectedValues = new Set();
    allSelects.forEach(select => {
      if (select.value) selectedValues.add(select.value);
    });
    allSelects.forEach(select => {
      Array.from(select.options).forEach(option => {
        const isSoldOut = option.dataset.soldOut === 'true';
        if (isSoldOut) {
          option.disabled = true;
          option.style.color = '#999999';
        } else if (option.value && selectedValues.has(option.value) && option.value !== select.value) {
          option.disabled = true;
          option.style.color = '#999999';
        } else if (option.value) {
          option.disabled = false;
          option.style.color = '';
        }
      });
    });
  }

  // --- Aktualizacja widoczności, CTA i cen ---
  function updateVisibility() {
    const allGroups = Array.from(document.querySelectorAll('.bundle-group'));
    let selectedCount = 0;

    allGroups.forEach((group, index) => {
      const select = group.querySelector('.select');
      if (select && select.value) {
        selectedCount++;
        if (index < allGroups.length - 1) {
          const nextGroup = allGroups[index + 1];
          if (window.getComputedStyle(nextGroup).display === 'none') {
            nextGroup.style.display = 'flex';
            requestAnimationFrame(() => {
              nextGroup.classList.add('visible');
            });
          }
        }
      }
    });

    const holderSelected = document.querySelector('#group-1').value !== '';
    paragraph1.style.display = holderSelected ? 'none' : 'block';
    paragraph2.style.display = holderSelected ? 'block' : 'none';

    const allSelected = allSelects.every(select => select.value !== '');
    submitBtn.disabled = !allSelected;

    // ✅ tłumaczenia w przycisku
    if (allSelected) {
      buttonText.textContent = window.translations?.add_to_cart_button || "Add to Cart";
    } else {
      const missing = 4 - selectedCount;
      buttonText.textContent = `${window.translations?.bundle_add || "Add "}${missing}${window.translations?.more_perfume || " more perfume"}`;
    }

    updateOptionsAvailability();
    updateTotalPrice();
  }

  // --- Przecena ---
  function updateTotalPrice() {
    const { currentEl, compareEl } = ensurePriceSpans();
    if (!currentEl || !compareEl) return;

    const allSelected = allSelects.every(select => select.value !== '');
    const { total, totalCompare } = getTotals();
    const baseSum = (totalCompare > 0) ? Math.max(totalCompare, total) : total;

    if (allSelected && baseSum > 0) {
      const discounted = applyBundleDiscount(baseSum);
      currentEl.textContent = formatPrice(discounted);

      if (baseSum > discounted) {
        compareEl.textContent = formatPrice(baseSum);
        compareEl.style.display = 'inline';
      } else {
        compareEl.textContent = '';
        compareEl.style.display = 'none';
      }
    } else {
      currentEl.textContent = '';
      compareEl.textContent = '';
    }
  }

  // --- Obsługa selectów ---
  form.addEventListener('change', (e) => {
    if (e.target && e.target.classList.contains('select')) {
      const groupNum = e.target.dataset.group;
      const imageDiv = document.getElementById(`image-group-${groupNum}`);
      if (imageDiv) {
        const imgElement = imageDiv.querySelector('img');
        const selectedOption = e.target.options[e.target.selectedIndex];
        const defaultImage = groupNum === '1' 
          ? 'https://cdn.shopify.com/s/files/1/0775/8495/7766/files/aluminium_1.jpg?v=1743536305'
          : 'https://cdn.shopify.com/s/files/1/0775/8495/7766/files/refillpink-vanillaGrey.jpg?v=1743539055';
        const imageUrl = (selectedOption && selectedOption.dataset.image) || defaultImage;
        if (imgElement) {
          imgElement.style.opacity = '0';
          setTimeout(() => {
            imgElement.src = imageUrl;
            imgElement.style.opacity = '1';
          }, 300);
        }
      }
      updateVisibility();
    }
  });

  // --- Submit ---
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const allSelected = allSelects.every(select => select.value !== '');
    
    if (allSelected) {
      const bundleId = Date.now();
      const items = allSelects.map(select => ({
        id: select.value,
        quantity: 1,
        properties: { _bundleId: bundleId, _bundleType: "car kit" }
      }));

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });
        
        if (response.ok) {
          window.location.href = '/cart';
        } else {
          throw new Error('Failed to add items to cart');
        }
      } catch (err) {
        modalMessage.textContent = 'Error adding items to cart. Please try again.';
        modal.style.display = 'flex';
      }
    } else {
      modalMessage.textContent = 'Please select 1 holder and 3 car scents before adding to the cart.';
      modal.style.display = 'flex';
    }
  });

  // --- Modal ---
  closeModal.addEventListener('click', () => modal.style.display = 'none');
  window.addEventListener('click', (e) => {
    if (e.target === modal) modal.style.display = 'none';
  });

  // --- Start ---
  ensurePriceSpans();
  updateVisibility();
});